var _desc, _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSubtask(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "16px",
    height: "16px",
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "subtask") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "subtask"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Subtask",
    transform: "translate(1.000000, 1.000000)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-36",
    fill: "#4BAEE8",
    x: 0,
    y: 0,
    width: 14,
    height: 14,
    rx: 2
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-80",
    stroke: "#FFFFFF",
    x: 3,
    y: 3,
    width: 5,
    height: 5,
    rx: 0.800000012
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-80-Copy",
    stroke: "#FFFFFF",
    fill: "#FFFFFF",
    x: 6,
    y: 6,
    width: 5,
    height: 5,
    rx: 0.800000012
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSubtask);
export default __webpack_public_path__ + "static/media/subtask.dc2246ab2daee645254b74fbf69e6654.svg";
export { ForwardRef as ReactComponent };